import { httpPut } from '../../../../Util/http';
import { addAlert } from '../../../../MsgNotify/msgNotifyActions';


export const DAILY_REPORT_ADD_ACTIVITY = 'DAILY_REPORT_ADD_ACTIVITY'
export const addActivity = () => (
    {
        type: DAILY_REPORT_ADD_ACTIVITY,
        activity: {
            name: '',
            hours: 0,
            activity: 'Diverse'
        }
    }
)

export const DAILY_REPORT_UPDATE_ACTIVITY_NAME = 'DAILY_REPORT_UPDATE_ACTIVITY_NAME'
export const updateActivityName = (activityName, activityIndex) => (
    {
        type: DAILY_REPORT_UPDATE_ACTIVITY_NAME,
        activityName,
        activityIndex
    }
)

export const DAILY_REPORT_UPDATE_ACTIVITY_HOURS = 'DAILY_REPORT_UPDATE_ACTIVITY_HOURS'
export const updateActivityHours = (activityHours, activityIndex) => (
    {
        type: DAILY_REPORT_UPDATE_ACTIVITY_HOURS,
        activityHours,
        activityIndex
    }
)

export const DAILY_REPORT_UPDATE_ACTIVITY_TOUCHED = 'DAILY_REPORT_UPDATE_ACTIVITY_TOUCHED'
export const updateActivityTouched = (inputType, activityIndex) => (
    {
        type: DAILY_REPORT_UPDATE_ACTIVITY_TOUCHED,
        activityIndex,
        inputType
    }
)

export const DAILY_REPORT_UPDATE_PREDEFINED_ACTIVITY = 'DAILY_REPORT_UPDATE_PREDEFINED_ACTIVITY'
export const updatePredefinedActivity = (activity, activityIndex) => (
    {
        type: DAILY_REPORT_UPDATE_PREDEFINED_ACTIVITY,
        activity,
        activityIndex
    }
)




export const isActivitiesValid = (dispatch, getState) => {

    let activities = getState().dailyReportActivitiesReducer.activities;

    let isActivitiesValid = true;
    activities.forEach((a, index) => {
        //if the activity is invalid act upon it
        if ((a.hours && !a.name && a.activity === 'Diverse')) {
            dispatch(updateActivityTouched('nameTouched', index))
            isActivitiesValid = false;
        }
    })

    return isActivitiesValid
}


export function attemptSaveActivities(currentDailyReportId, getState, dispatch) {
    var _url = process.env.REACT_APP_webApiEndPoint + 'api/dailyreport/activity/register'
    let activities = getState().dailyReportActivitiesReducer.activities;
    let activitiesToSave = filterSaveAbleActivities(activities);
    return httpPut(_url, { id: currentDailyReportId, activities: activitiesToSave })
        .catch(() => {
            dispatch(addAlert("Kunne ikke gemme aktiviteterne"))
            throw new Error("Kunne ikke gemme aktiviteterne")
        })
}


function filterSaveAbleActivities(activities) {
    let result = [];
    activities.forEach((a) => {
        if (a.hours > 0) {
            result.push(a);
        }
    })
    return result;
}


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/DailyReport/Activities/actions.js